import {
    PortSuggestionMessage,
    PortSuggestionStreamEvent,
    streamPortSuggestions,
} from '../../../common/api/clients/intelligence.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { useIntelligenceStream, UseIntelligenceStreamResult } from '../../create-enquiry/hooks/useIntelligenceStream';

export const usePortSuggestionsStream = (
    orderId: string
): UseIntelligenceStreamResult<PortSuggestionMessage, PortSuggestionStreamEvent> => {
    return useIntelligenceStream<PortSuggestionMessage, PortSuggestionStreamEvent>(orderId, {
        queryKey: queries.intelligence.portSuggestions(orderId).queryKey,
        streamFunction: streamPortSuggestions,
        streamName: 'Port suggestions',
    });
};
